export default __webpack_public_path__ + "static/media/netflixFondo.fad87ac4.png";